import { render } from "./Drainage.vue?vue&type=template&id=b1be2816"
import script from "./Drainage.vue?vue&type=script&lang=js"
export * from "./Drainage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__